import { render, staticRenderFns } from "./CompletedDetails.vue?vue&type=template&id=7e609a28"
import script from "./CompletedDetails.vue?vue&type=script&lang=js"
export * from "./CompletedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports